import { cn } from '@/lib/utils'
import type { SVGProps } from 'react'

export const OpenCodeLogo = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 512 512"
    fill="none"
    {...props}
    className={cn('*:[path]:fill-primary', props.className)}
  >
    <path fill="#17181C" d="M320 224V352H192V224H320Z" fillOpacity={0.3} />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M384 416H128V96H384V416ZM320 160H192V352H320V160Z"
      fill="#17181C"
    />
  </svg>
)
